import classNames from 'classnames';
import dayjs from 'dayjs';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { HasClassName } from '../component-utils';
import './Calendar.scss';
import { ReactComponent as DropdownIcon } from './icons/dropdown-icon.svg';

interface Props extends HasClassName {
  value: number
  onChange(value: number): void
  onHide?(): void
  disabled?:boolean
}

export default function Calendar({ className, value, onChange, onHide, disabled }: Props) {
  return <ReactDatePicker calendarClassName={classNames('Calendar', className)} disabled={disabled} showDisabledMonthNavigation={disabled}
    inline peekNextMonth useWeekdaysShort onClickOutside={onHide}
    selected={new Date(value)} onChange={d => d && !disabled && onChange(d.getTime())}
    renderDayContents={(_, d) => dayjs(d).format('DD')}
    previousMonthButtonLabel={<DropdownIcon className='prevIcon' /> as any}
    nextMonthButtonLabel={<DropdownIcon className='nextIcon' /> as any} />
}
